import Icon from '@cobliteam/ui/icons';
import type { UIMessage } from 'ai';
import { Shimmer } from './Shimmer';

interface LoadingProps {
  message: UIMessage;
  isAssistant: boolean;
}

const Loading = ({ message, isAssistant }: LoadingProps) => {
  if (!isAssistant) return null;

  // have more then 1 part
  const hasMoreThanOnePart = message.parts.length > 1;
  if (hasMoreThanOnePart) return null;

  return (
    <div className='mt-2 flex w-full items-center gap-1 px-3'>
      <Icon name='loader-circle' size='sm' color='gray-dark' className='animate-spin' aria-hidden='true' />
      <Shimmer duration={1} className='text-sm'>
        Iniciando...
      </Shimmer>
    </div>
  );
};

export default Loading;
